import { useEffect, useRef, type ReactNode } from 'react';

interface Props {
  ouvert: boolean;
  titre: string;
  onFermer: () => void;
  children: ReactNode;
  large?: boolean;
}

/** Boîte de dialogue modale native (<dialog>), fermée par Échap ou clic hors de la boîte. */
export function Dialogue({ ouvert, titre, onFermer, children, large = false }: Props) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (ouvert && !d.open) {
      if (typeof d.showModal === 'function') d.showModal();
      else d.setAttribute('open', '');
    } else if (!ouvert && d.open) {
      if (typeof d.close === 'function') d.close();
      else d.removeAttribute('open');
    }
  }, [ouvert]);
  return (
    <dialog
      ref={ref}
      className={`dialogue${large ? ' large' : ''}`}
      aria-labelledby="dialogue-titre"
      onClose={onFermer}
      onClick={(e) => {
        if (e.target === ref.current) onFermer();
      }}
    >
      <div className="dialogue-corps">
        <div className="entete-page" style={{ alignItems: 'center' }}>
          <h2 id="dialogue-titre" className="display" style={{ fontSize: 26 }}>
            {titre}
          </h2>
          <button type="button" className="btn" onClick={onFermer} aria-label="Fermer">
            ✕
          </button>
        </div>
        {ouvert ? children : null}
      </div>
    </dialog>
  );
}
